// Malaysian banks & e-wallets — payment method tiles (styled wordmarks).
// Wordmark approach guarantees crisp rendering without depending on
// third-party logo CDNs. Brand colors map roughly to each provider's identity.
export const PAYMENTS = [
  {
    id: "maybank",
    name: "Maybank",
    short: "Maybank",
    bg: "#ffd400",
    fg: "#0a0a0a",
    accent: "#000",
  },
  {
    id: "cimb",
    name: "CIMB Bank",
    short: "CIMB",
    bg: "#ffffff",
    fg: "#a3122c",
    accent: "#a3122c",
  },
  {
    id: "publicbank",
    name: "Public Bank",
    short: "Public Bank",
    bg: "#ffffff",
    fg: "#c8102e",
    accent: "#003875",
  },
  {
    id: "rhb",
    name: "RHB Bank",
    short: "RHB",
    bg: "#003da6",
    fg: "#ffffff",
    accent: "#ffffff",
  },
  {
    id: "hlb",
    name: "Hong Leong Bank",
    short: "Hong Leong",
    bg: "#ffffff",
    fg: "#005baa",
    accent: "#005baa",
  },
  {
    id: "tng",
    name: "Touch 'n Go eWallet",
    short: "TnG eWallet",
    bg: "#1f6dd5",
    fg: "#ffffff",
    accent: "#ffd400",
  },
  {
    id: "boost",
    name: "Boost",
    short: "Boost",
    bg: "#ed1c24",
    fg: "#ffffff",
    accent: "#ffffff",
  },
  {
    id: "duitnow",
    name: "DuitNow",
    short: "DuitNow",
    bg: "#ffffff",
    fg: "#ed1c24",
    accent: "#ed1c24",
  },
];
